"use client"

import React from "react"
import Header from "@/components/layout/Header"
import data from "@/mock/home"
import { TSiteConfiguration } from "@/types/base"
import Footer from "../layout/Footer"
import { useConfig } from "@/context/ConfigContext"

interface LayoutProps {
  children: React.ReactNode
  configData?: TSiteConfiguration
}

export function Layout({ children, configData }: LayoutProps) {
  const defaultConfigData = configData || data?.siteConfiguration
  const contextData = useConfig()

  return (
    <div className="max-w-[1250px] mx-auto w-full pt-4 lg:pt-8 px-4 pb-16">
      <Header data={defaultConfigData} />
      <main className="relative m-auto">{children}</main>
      <Footer data={contextData} />
    </div>
  )
}
